interface CopyrightConfig {
  text: string;
  isNeedVersion: boolean;
}

export const COPYRIGHT_TEXT: Record<string, CopyrightConfig> = {
  ZURICH: {
    text: "Zurich - Zurich Group Protector Portal",
    isNeedVersion: true
  },
  // Add more partner codes and their copyright texts here
} as const;

export const getCopyrightText = (partnerCode: string): string => {
  if (!partnerCode || partnerCode === "GENERAL") {
    return "FalconEdge";
  }

  return (
    COPYRIGHT_TEXT[partnerCode]?.text ||
    partnerCode.charAt(0).toUpperCase() + partnerCode.slice(1).toLowerCase()
  );
};
